import * as types from './mutation-types'
import client from '@/base/api/client'
export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.login', input: authInfo } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('user', data.auth.output)
          localStorage.setItem('userID', data.auth.output.id)
          localStorage.setItem('userRole', data.auth.output.user_type)
          localStorage.setItem('username', data.auth.output.username)
          localStorage.setItem('token', '1')
        }
        commit(types.AUTH_LOGIN, localStorage.getItem('token'))
      })
      .catch(err => { throw err })
  },
  logout: ({ commit, state }) => {
    localStorage.removeItem('name')
    localStorage.removeItem('username')
    localStorage.removeItem('role')
    localStorage.removeItem('token')
    return client.auth({ data: { auth: {api: 'AuthService.logout'} } })
      .then((data) => {
        commit(types.AUTH_LOGOUT, null)
      })
  },
  initUser: ({ commit, state }) => {
    return client.auth({ data: { search: { api: 'AuthService.getLoginUser', input: {} } } })
      .then((data) => {
        commit(types.AUTH_LOGIN, data.search.output)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth/actions.js